export default "__VITE_ASSET__Ccrsf$cG__"